import { gql } from '@apollo/client';

/**
 * 揽收进度页「问题预约单详情页」(POP) 查询。
 * 网关 getPopAppointmentDetail → pickup-service PopAppointmentDetailDubboService。
 */
export const GET_POP_APPOINTMENT_DETAIL = gql`
  query GetPopAppointmentDetail($appointmentId: Long!) {
    getPopAppointmentDetail(appointmentId: $appointmentId) {
      appointmentId
      appointmentNumber
      expectedPickupDate
      channelId
      pickupSiteId
      pickupSiteName
      siteAddress
      contactName
      contactPhone
      exceptionReasonCode
      arrivedAt
      pickupGpsLatitude
      pickupGpsLongitude
      distanceMeters
      reviewStatus
      reviewerId
      reviewerName
      disqualifyReasonCodesJson
      reviewRemark
      photosS3UrlJson
    }
  }
`;

export interface PopAppointmentDetail {
  appointmentId: number;
  appointmentNumber?: string;
  expectedPickupDate?: string;
  channelId?: number;
  pickupSiteId?: number;
  pickupSiteName?: string;
  siteAddress?: string;
  contactName?: string;
  contactPhone?: string;
  exceptionReasonCode?: string;
  arrivedAt?: string;
  pickupGpsLatitude?: number;
  pickupGpsLongitude?: number;
  distanceMeters?: number;
  reviewStatus?: string;
  reviewerId?: number;
  reviewerName?: string;
  disqualifyReasonCodesJson?: string;
  reviewRemark?: string;
  photosS3UrlJson?: string;
}

export interface GetPopAppointmentDetailResponse {
  getPopAppointmentDetail: PopAppointmentDetail | null;
}
